import React, { useState, useEffect, useMemo } from "react";
import SidebarHeader from "./SidebarHeader";
import MenuLink from "../MenuLink";
import { Menu } from "semantic-ui-react";
import Sidebar from "components/Sidebar/Sidebar";
import { Link, useLocation } from "react-router";

const getApiType = (location) => {
  const pathSegments = location.pathname.split("/");
  return pathSegments[2] === "rest" ? "restApis" : "websocketApis";
};

function EndpointACLCollapse({ title, apiList, showTable, path }) {
  const location = useLocation();
  const [isCollapse, setisCollapse] = useState(
    location.pathname.split("/")?.[2] === path
  );

  const collapse = () => {
    setisCollapse((state) => !state);
  };

  useEffect(() => {
    setisCollapse(location.pathname.split("/")?.[2] === path);
  }, [location.pathname, path]);

  return (
    <>
      <SidebarHeader
        onClick={collapse}
        style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
      >
        {title}
        <span
          className="material-symbols-outlined"
          style={{
            transform: `rotate(${isCollapse ? 180 : 0}deg)`,
            transition: "all 0.25s",
          }}
        >
          expand_more
        </span>
      </SidebarHeader>

      {isCollapse &&
        (apiList.length > 0 ? (
          <AclApiCollapse
            index={3}
            path={"/endpoint-security/" + path}
            style={{ paddingLeft: "7px" }}
            data={apiList}
            showTable={showTable}
            idProperty="title"
          />
        ) : (
          <Menu.Item style={{ paddingLeft: "10px" }}>
            No results found
          </Menu.Item>
        ))}
    </>
  );
}
export default EndpointACLCollapse;

export function AclApiCollapse({ data, path, index, showTable, idProperty }) {
  const location = useLocation();
  const [active, setActive] = useState(
    location.pathname.startsWith(path)
      ? location.pathname.split("/")?.[index]
      : null
  );

  const findActive = () => {
    return data.find((element) => element[idProperty] === active);
  };

  const hasContent = () => {
    return findActive()?.content;
  };

  useEffect(() => {
    setActive(
      location.pathname.startsWith(path)
        ? location.pathname.split("/")?.[index]
        : null
    );
  }, [location.pathname, path, index]);

  useEffect(() => {
    if (findActive() && !hasContent()) {
      showTable(findActive(), getApiType(location));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, data, path, active]);

  const expandOrCollapse = (data) => {
    setActive(data[idProperty] === active ? null : data[idProperty]);
  };

  return (
    <Sidebar>
      {data.map((data) => (
        <React.Fragment key={data[idProperty]}>
          <Menu.Item
            className="link"
            as={data.name ? Link : "a"}
            active={active === data[idProperty]}
            onClick={() => expandOrCollapse(data)}
            to={data.name ? path + "/" + data.name : null}
            style={{
              fontWeight: "400",
              paddingLeft: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {data[idProperty]}
            {Array.isArray(data.content) && (
              <span
                className="material-symbols-outlined"
                style={{
                  transform: `rotate(${
                    active === data[idProperty] ? 180 : 0
                  }deg)`,
                  transition: "all 0.25s",
                }}
              >
                expand_more
              </span>
            )}
          </Menu.Item>
          {active === data[idProperty] && Array.isArray(data.content) && (
            <Menu.Item style={{ padding: "0 1em" }}>
              <AclApiCollapse
                index={index + 1}
                path={path + "/" + data[idProperty]}
                style={{ paddingLeft: "7px" }}
                data={data.content}
                showTable={showTable}
                idProperty="name"
              />
            </Menu.Item>
          )}
        </React.Fragment>
      ))}
    </Sidebar>
  );
}

export function AsyncApiCollapse({ data, apiDirectory, index, url }) {
  const [active, setActive] = useState(null);
  useMemo(() => {
    setActive(apiDirectory.length ? apiDirectory[index] : null);
  }, [apiDirectory, index]);
  const dropdown = (data) => {
    const { title, content, error } = data;
    setActive(
      title === active ? (content[0].asyncapi || error ? title : null) : title
    );
  };

  const hasContent = ({ content, error }) =>
    (content.length ? content[0].asyncapi || error : false) ? true : false;

  return (
    <>
      {data.map((data) => (
        <React.Fragment key={data.title}>
          <MenuLink
            onClick={() => dropdown(data)}
            to={hasContent(data) ? url + "/" + data.title : null}
            active={active === data.title}
            style={{ fontWeight: "400", display: "flex", alignItems: "center" }}
          >
            {data.title}
            {!hasContent(data) && (
              <span
                className="material-symbols-outlined"
                style={{
                  transform: `rotate(${active === data.title ? 180 : 0}deg)`,
                  transition: "all 0.25s",
                }}
              >
                expand_more
              </span>
            )}
          </MenuLink>

          {active === data.title && !hasContent(data) && (
            <Menu.Item style={{ padding: "0 1em" }}>
              {data.content.length !== 0 && (
                <AsyncApiCollapse
                  data={data.content}
                  style={{ paddingLeft: "7px" }}
                  apiDirectory={apiDirectory}
                  index={index + 1}
                  url={url + "/" + data.title}
                />
              )}
            </Menu.Item>
          )}
        </React.Fragment>
      ))}
    </>
  );
}

export function RestAPIsCollapse({ data, path, index }) {
  const [active, setActive] = useState(null);
  const resultantPath = path.split("/");

  useEffect(() => {
    resultantPath.length && setActive(resultantPath[index]);
    if (data.length === 1) setActive(data[0].title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, data, path]);

  const showContent = (data) => {
    const { title } = data;
    setActive(title === active ? null : title);
  };

  return (
    <Sidebar>
      {data.map((data) => (
        <React.Fragment key={data.title}>
          <MenuLink
            active={active === data.title}
            onClick={() => showContent(data)}
            to={!Array.isArray(data.content) && `/apis/${data.title}`}
            style={{
              fontWeight: "400",
              paddingLeft: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {data.title}
            {Array.isArray(data.content) && (
              <span
                className="material-symbols-outlined"
                style={{
                  transform: `rotate(${active === data.title ? 180 : 0}deg)`,
                  transition: "all 0.25s",
                }}
              >
                expand_more
              </span>
            )}
          </MenuLink>
          {active === data.title && Array.isArray(data.content) && (
            <Menu.Item style={{ padding: "0 1em" }}>
              <RestAPIsCollapse
                index={index + 1}
                path={path}
                style={{ paddingLeft: "7px" }}
                data={data.content}
              />
            </Menu.Item>
          )}
        </React.Fragment>
      ))}
    </Sidebar>
  );
}
